// Day-of-week utilities and time parsing

// Map lowercase weekday name to 1..7 (Mon..Sun)
export const dayNameToNumber: Record<string, number> = {
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
  sunday: 7,
};

// Count how many times a given weekday (1..7 Mon..Sun) occurs in [startDate, endDate]
export function countWeekdaysInPeriod(weekday: number, startDate: Date, endDate: Date): number {
  let count = 0;
  const cur = new Date(startDate);
  while (cur <= endDate) {
    const wd = cur.getDay() === 0 ? 7 : cur.getDay();
    if (wd === weekday) count++;
    cur.setDate(cur.getDate() + 1);
  }
  return count;
}

// Parse time string HH:MM to minutes since midnight
export function parseTime(timeStr: string): number {
  if (typeof timeStr !== 'string') return NaN;
  const trimmed = timeStr.trim();
  if (!trimmed) return NaN;
  const match = /^(\d{1,2}):(\d{2})$/.exec(trimmed);
  if (!match) return NaN;
  const hours = Number.parseInt(match[1], 10);
  const minutes = Number.parseInt(match[2], 10);
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return NaN;
  if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return NaN;
  return hours * 60 + minutes;
}

